<i3jwt-default-container [titulo]="'NOT_FOUND.TITLE'" [icono]="'error'" [template]="error">
</i3jwt-default-container>

<ng-template #error>
  <p>{{ 'NOT_FOUND.CONTENT' | translate }}</p>
</ng-template>